
import React, { Component } from 'react';
import { Modal, Form, Input, TreeSelect, Select, Switch } from 'antd';

import http from '../../../axios/http';
import { treeDataConversion } from '../../ui/treeData';

import messager from '../../ui/messager';
import validator from '../../../util/validator';
import {global_data} from "../../ui/auth";

const FormItem = Form.Item;

class UserEditForm extends Component {

    state = {
        orgTree: [],
        roleList: []
    }

    componentDidMount() {
        this.loadOrgTree();
        this.loadRoleList();
    }

    loadOrgTree = () => {
        http.post({
            url: '/auth/findOrgTree',
            success: (res) => {
                treeDataConversion(res);
                this.setState({ orgTree: res });
            }
        });
    }

    loadRoleList = () => {
        http.post({
            url: '/auth/findAuthRole',
            success: (res) => {
                this.setState({ roleList: res });
            }
        });

    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            values["loginByCAM"] = values["loginByCAM"] ? 1 : 0;
            // values["loginByOTP"] = values["loginByOTP"] ? 1 : 0;
            http.post({
                url: '/user/saveUser',
                data: values,
                success: (res) => {
                    messager.notify("保存成功！");
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                }
            });
        });
    };

    render() {
        const { visible, onCancel, form, editData } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                visible={visible}
                title="用户编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    <FormItem label="用户名：">
                        {getFieldDecorator('username', {
                            rules: [
                                { required: true, message: '请输入用户名!' },
                                { max: 32, message: '最多只能输入32个字符！' },
                                validator.enNumChar
                            ],
                            initialValue: editData.username,
                        })(
                            <Input disabled={editData.username !== undefined && editData.username != null} />
                        )}
                    </FormItem>
                    <FormItem label="名称/姓名：">
                        {getFieldDecorator('name', {
                            rules: [
                                { required: true, message: '请输入名称/姓名!' },
                                { max: 32, message: '最多只能输入32个字符！' }],
                            initialValue: editData.name,
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label="身份证号：">
                        {getFieldDecorator('idNo', {
                            rules: [
                                validator.creditNo
                            ],
                            initialValue: editData.idNo,
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label="联系电话：">
                        {getFieldDecorator('tel', {
                            rules: [
                                { required: true, message: '请输入联系电话!' },
                                validator.tel],
                            initialValue: editData.tel,
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label="用户类型：">
                        {getFieldDecorator('type', {
                            initialValue: editData.type == null ? '0' : '' + editData.type,
                        })(
                            <Select>
                                <Select.Option key="0">普通员工</Select.Option>
                                <Select.Option key="1">开票人员</Select.Option>
                                <Select.Option key="2">代办</Select.Option>
                                <Select.Option key="3">租户</Select.Option>
                                <Select.Option key="4">商城用户</Select.Option>
                            </Select>
                        )}
                    </FormItem>
                    <FormItem label="使用CAM登录：">
                        {getFieldDecorator('loginByCAM', {
                            initialValue: editData['loginByCAM'] === 1,
                            valuePropName: 'checked'
                        })(
                            <Switch checkedChildren="是" unCheckedChildren="否" />
                        )}
                    </FormItem>
                    {/*<FormItem label="使用OTP登录：">*/}
                    {/*    {getFieldDecorator('loginByOTP', {*/}
                    {/*        initialValue: editData['loginByOTP'] === 1,*/}
                    {/*        valuePropName: 'checked'*/}
                    {/*    })(*/}
                    {/*        <Switch checkedChildren="是" unCheckedChildren="否" />*/}
                    {/*    )}*/}
                    {/*</FormItem>*/}
                    <Form.Item label="所属组织：" >
                        {getFieldDecorator('orgCode', {
                            initialValue: editData.orgCode,
                            rules: [{ required: true, message: '请选择组织!' }],
                        })(
                            <TreeSelect
                                //treeCheckable={true}
                                multiple={true}
                                treeData={this.state.orgTree}
                                treeDefaultExpandAll={true}
                            //treeCheckStrictly={true}
                            //labelInValue={false}
                            />
                        )}
                    </Form.Item>
                    <FormItem label="角色信息：">
                        {getFieldDecorator('roleId',
                            {
                                initialValue: editData.roleId == null ? [] : editData.roleId,
                            }
                        )(
                            <Select
                                disabled={!global_data.authCode.includes("SYS_USER_ROLE_UPDATE")}
                                mode="multiple"
                                showSearch={true}
                                optionFilterProp="children"
                                filterOption={(input, option)=>option?.props?.children?.toLowerCase().includes(input.toLowerCase())}
                            >
                                {this.state.roleList.map(d => <Select.Option key={d.roleId}>{d.roleName}</Select.Option>)}
                            </Select>
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}

const UserEdit = Form.create()(UserEditForm);

export default UserEdit;
